export enum DentalLabFormMode {
  CREATE = "create",
  EDIT = "edit"
}

export enum DentalLabOrderStatus {
  ORDERED = "ordered",
  DELIVERED = "delivered",
  CANCELLED = "cancelled"
}
